import { Navigate } from "react-router-dom";
import { ROUTES } from "../consts/routes.consts";
import { useGetUsersListQuery } from "../apis/userDetailsAPi";
import { CircularProgress } from "@mui/material";
import MetaAdsBuilder from "../../pages/dashboard/meta-ads-builder";

const ALLOWED_EMAIL = "mapsjohn89@gmail.com";

export const ProtectedMetaAdsRoute = () => {
  const { data: userData, isLoading } = useGetUsersListQuery<any>();
  const user = userData?.user;
  const userEmail = user?.email;

  // Show loading spinner while fetching user data
  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[9999] min-h-screen flex items-center justify-center backdrop-blur-[20px] bg-[rgba(0,0,0,0.5)]">
        <CircularProgress size={50} style={{ color: "#ffffff" }} />
      </div>
    );
  }

  // Check if user is logged in and has the allowed email
  if (!userEmail || userEmail !== ALLOWED_EMAIL) {
    return <Navigate to={ROUTES.HOME} replace={true} />;
  }

  // User has the correct email, allow access
  return <MetaAdsBuilder />;
};

